import { Theme } from "@mui/material/styles";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
    container: {
        display: "flex",
        alignItems: "center",
    },
    menuItem: {
        minWidth: theme.width.width85_5,
    },
});